export function Logo({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 44 44" className={className} fill="none" role="img" aria-label="Colorspol">
      <rect x="10" y="10" width="24" height="24" stroke="currentColor" strokeWidth="2.5" />
      <rect
        x="10"
        y="10"
        width="24"
        height="24"
        stroke="currentColor"
        strokeWidth="2.5"
        transform="rotate(45 22 22)"
      />
      <text
        x="22"
        y="28.5"
        textAnchor="middle"
        fontFamily="Zilla Slab, serif"
        fontWeight="700"
        fontSize="17"
        fill="currentColor"
      >
        C
      </text>
    </svg>
  )
}
